import { Arrow, Content } from '@radix-ui/react-tooltip'
import { invert } from 'polished'
import styled from 'styled-components'

import type { AdvancedColors, ColorShade, Variant, Width } from '../../../themes'
import { getForegroundColor } from '../../../themes/helpers'
import type { Size } from '../../../themes/types'
import { hoverAnimation } from '../../../utils/styles/animations.styles'

const getBackgroundColor = (colors: AdvancedColors, variant: Variant, shade: ColorShade) => {
  if (variant === 'black') return '#262626'
  if (variant === 'white') return variant

  return colors[variant][shade]
}

export const StyledContent = styled(Content)<{
  $maxWidth?: Width
  $minWidth: Width
  $spacing: Size
  $variant: Variant
}>`
  z-index: 1000000;
  border-radius: ${props => props.theme.dimensions.borderRadius};
  padding: ${props => props.theme.spacings[props.$spacing]};
  max-width: ${props => props.$maxWidth ?? 'initial'};
  min-width: ${props => props.$minWidth};
  background-color: ${props => getBackgroundColor(props.theme.colors, props.$variant, 'base')};
  border: 1px solid ${props => getBackgroundColor(props.theme.colors, props.$variant, 'dark')};
  color: ${props =>
    props.$variant === 'black' || props.$variant === 'white'
      ? invert(props.$variant)
      : getForegroundColor(props.$variant, props.theme)};

  ${hoverAnimation}
`

export const StyledArrow = styled(Arrow)<{ $variant: Variant }>`
  fill: ${props => getBackgroundColor(props.theme.colors, props.$variant, 'base')};
`
